const axios = require('axios');
const moment = require('moment');
import { getOffers } from "@/api/offers";

async function getOtherAvailableHaulages(offer, productConfig, matchHaulageList, itemsList, eligibleOffersList) {
  let haulageMatches = matchHaulageList;
  let offerIds = itemsList;
  let eligibleOffers = eligibleOffersList;
  const { DieselId, BlendedDieselBioId, GasoilId, BlendedGasoilId, KeroseneId } = productConfig;

  try {
    /* Fetch the updated offers and haulage lists, then fetch other eligible products */
    const { offers, haulageOffers } = await getOffers({ sellerAccountIds: [offer.haulage_account_id] });

    let excludedFuelIds = [];
    switch (offer.fuel.id) {
      case DieselId:
      case BlendedDieselBioId:
        excludedFuelIds = [DieselId, BlendedDieselBioId];
        break;
      case GasoilId:
      case BlendedGasoilId:
        excludedFuelIds = [GasoilId, BlendedGasoilId];
        break;
      case KeroseneId:
        excludedFuelIds = [KeroseneId];
        break;
    }
    haulageMatches = Object.assign(
      [],
      haulageOffers.filter(
        (haulage) =>
          // Match the haulages to determine whether they can be added to the basket or not
          haulage.offer_id !== offer.offer_id &&
          !excludedFuelIds.includes(haulage.fuel.id) &&
          haulage.offer_account_id == offer.offer_account_id &&
          haulage.haulage_account_id == offer.haulage_account_id &&
          haulage.location_id == offer.location_id &&
          haulage.terminal.id == offer.terminal.id &&
          moment(haulage.deliveryDate).format("DD-MM-YYYY") == moment(offer.deliveryDate).format("DD-MM-YYYY")
      )
    );

    for (const haulage of haulageMatches) {
      offerIds.push({ offerId: haulage.offer_id });
      eligibleOffers.push(
        Object.assign(
          {},
          offers.find((liveOffer) => liveOffer._id == haulage.offer_id)
        )
      );
    }
  } catch (error) {
    console.dir(error);
  }

  return { haulageMatches, offerIds, eligibleOffers };
}

export {
  getOtherAvailableHaulages
};